export default __webpack_public_path__ + "static/media/shower.df9cc8db.svg";